module.exports = __webpack_public_path__ + "static/andrew-chen-aaeb8cde2ab3e726ea58c6c279c369b9.jpg";